// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bncfi","option":"styles_option__2KNut","active":"styles_active__23Aj7"};